import React from "react";


export default function Ustawienia ({socket,hipopotemDialogBox,setIsOpen}){

  return(
                  <li
  //               onClick={() => {
  //                 if (socket) {
  //                   socket.emit("ktotam");
  //                 }

  // hipopotemDialogBox.current.show();
  // hipopotemDialogBox.current.showOK();
  // hipopotemDialogBox.current.hide();



  //                 setIsOpen(false);
  //               }}
              >
                Ustawienia
              </li>
  )
}